import { Heart, Mail, Shield, LifeBuoy } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-24 py-12" style={{ backgroundColor: '#F3EFE7', borderTop: '1px solid rgba(44, 39, 36, 0.08)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 rounded-xl" style={{ backgroundColor: '#E57A44' }}>
              <Heart className="w-5 h-5" style={{ color: '#FDFBF7', strokeWidth: 2 }} />
            </div>
            <span className="text-xl font-semibold" style={{ fontFamily: 'Playfair Display, serif', color: '#2C2724' }}>Love Restored</span>
          </div>

          <div className="flex items-center gap-2 sm:gap-4 flex-wrap">
            <Link to="/contact" className="flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-300 hover:-translate-y-0.5" style={{ fontFamily: 'Manrope, sans-serif', color: '#5C564D', fontWeight: 500 }} data-testid="footer-contact-link">
              <Mail className="w-4 h-4" style={{ strokeWidth: 2 }} />
              <span>Contact</span>
            </Link>
            <Link to="/resources" className="flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-300 hover:-translate-y-0.5" style={{ fontFamily: 'Manrope, sans-serif', color: '#5C564D', fontWeight: 500 }} data-testid="footer-resources-link">
              <LifeBuoy className="w-4 h-4" style={{ strokeWidth: 2 }} />
              <span>Resources</span>
            </Link>
            <Link to="/terms" className="flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-300 hover:-translate-y-0.5" style={{ fontFamily: 'Manrope, sans-serif', color: '#5C564D', fontWeight: 500 }} data-testid="footer-terms-link">
              <Shield className="w-4 h-4" style={{ strokeWidth: 2 }} />
              <span>Terms</span>
            </Link>
          </div>
        </div>

        <div className="mt-8 text-center space-y-1" style={{ fontFamily: 'Manrope, sans-serif', color: '#8C867D', fontSize: '14px' }}>
          <p data-testid="footer-attribution">Created with love by <span style={{ color: '#E57A44', fontWeight: 600 }}>Genesis Natera</span></p>
          <p>© 2026 Love Restored. Building stronger relationships through faith.</p>
          <p className="text-xs mt-2" style={{ color: '#B0AA9E' }}>
            Faith-based guidance, not licensed therapy or medical advice. See <Link to="/terms" style={{ color: '#8C867D', textDecoration: 'underline' }}>Terms</Link> for details.
          </p>
        </div>
      </div>
    </footer>
  );
}
